import { motion } from 'framer-motion'
import styled from 'styled-components'

import media from '../../../utils/media'
import Icon from '../../helpers/Icon'

export const AccordionWrapper = styled.div`
  flex-shrink: 0;
`

export const AccordionHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`

export const AccordionTitle = styled.h3`
  margin-right: auto;
`

export const AccordionChevron = styled(Icon)`
  transition: transform ease 0.4s;
  transform: rotate(0);
`

export const AccordionContent = styled(motion.div)`
  overflow: hidden;
`

export const AccordionItem = styled.div`
  &.expanded {
    ${AccordionChevron} {
      transform: rotate(180deg);
    }
  }

  &.only-mobile {
    ${media.greaterThan('sm')`
      ${AccordionContent} {
        display: block !important;
        opacity: 1 !important;
        height: auto !important;
      }

      ${AccordionHeading} {
        pointer-events: none;
        cursor: default;
      }
    `}
  }
`
